<div class="swapa-media-block h-100 d-flex flex-column" *ngIf="config && (config.ImageUrl || config.Headline || config.Summary)">
    <div class="swapa-media-block-image-wrapper overflow-hidden" *ngIf="config.ImageUrl">
        <img class="swapa-media-block-image w-100" [src]="config.ImageUrl" alt="" />
    </div>
    <div class="swapa-media-block-text flex-fill d-flex flex-column">
        <div class="swapa-media-block-meta text-uppercase" *ngIf="config.Tag">
            <span class="swapa-media-block-tag">{{ config.Tag }}</span>
        </div>
        <h3 class="swapa-media-block-headline font-weight-bold overflow-hidden mb-0" *ngIf="config.Headline"
            [clampTooltip]="config.Headline">
            <a *ngIf="config.LinkUrl" class="text-reset" [href]="config.LinkUrl">{{ config.Headline }}</a>
            <ng-container *ngIf="!config.LinkUrl">{{ config.Headline }}</ng-container>
        </h3>
        <p class="swapa-media-block-summary overflow-hidden mb-0" *ngIf="config.Summary"
           [clampTooltip]="config.Summary">
            <a *ngIf="config.LinkUrl" class="text-reset" [href]="config.LinkUrl">{{ config.Summary }}</a>
            <ng-container *ngIf="!config.LinkUrl">{{ config.Summary }}</ng-container>
        </p>
        <div class="swapa-media-block-date" *ngIf="config.Date">{{ config.Date }}</div>
    </div>
</div>
